import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import Button from 'jbc-front/components/Button';
import { PdfFile } from 'jbc-front/components/icons';

import Loading from 'src/components/Loading';
import { INITIAL_POLLING_INTERVAL } from 'src/constants/Generals';
import PdfCreateModalContainer from '../containers/PdfCreateModalContainer';
import PdfDownloadModalContainer from '../containers/PdfDownloadModalContainer';
import PdfExportMethod from './PdfExportMethod';
import styles from '../ReportWageLedgerList.scss';

const ExportButton = props => {
  const { searchParams, isCreated, isCreating, year, uniqueString } = props;
  const [isPdfExportOpen, setPdfExportOpen] = useState(false);
  const [isCreateModalOpen, setCreateModalOpen] = useState(false);
  const [isDownloadModalOpen, setDownloadModalOpen] = useState(false);

  useEffect(
    () => {
      const { fetchExportWageLedgerStatus, jobStatus } = props;
      if (jobStatus.status === undefined || jobStatus.status === 'success') {
        return;
      }
      fetchExportWageLedgerStatus(INITIAL_POLLING_INTERVAL, year, uniqueString);
    },
    [props.jobStatus.status]
  );

  return (
    <div className={styles.wrap}>
      <div className={styles.loading}>
        {isCreating && (
          <Button primary widthWide disabled icon={<Loading />} className={styles.loadingButton}>
            データ作成中
          </Button>
        )}
        {!isCreating && (
          <React.Fragment>
            <Button
              disabled={!isCreated && _.isEmpty(searchParams)}
              primary
              onClick={() => setPdfExportOpen(true)}
              className={styles.createButton}
              widthWide
              icon={<PdfFile size={16} />}
            >
              PDF一括出力
            </Button>
            {isPdfExportOpen && (
              <PdfExportMethod
                hide={() => setPdfExportOpen(false)}
                searchParams={searchParams}
                isCreated={isCreated}
                openDownloadModal={() => setDownloadModalOpen(true)}
                openCreateModal={() => setCreateModalOpen(true)}
              />
            )}
            <PdfCreateModalContainer
              isOpen={isCreateModalOpen}
              hideModal={() => setCreateModalOpen(false)}
              params={searchParams}
            />
            <PdfDownloadModalContainer
              isOpen={isDownloadModalOpen}
              hideModal={() => setDownloadModalOpen(false)}
              year={year}
            />
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default ExportButton;
